<template>
  <el-submenu v-if="visible && hasChildren" :index="menu.index">
    <template slot="title">
      <i :class="menu.icon"></i>
      <span>{{ menu.label }}</span>
    </template>
    <MenuItems v-for="child in menu.children" :key="child.index" :menu="child" />
  </el-submenu>
  <el-menu-item v-else-if="visible" :index="menu.index">
    <i :class="menu.icon"></i>
    <span slot="title">{{ menu.label }}</span>
  </el-menu-item>
</template>

<script>
import { immediateModules, immediateRole } from '../../assets/utils/immediateLoadingPermissions'
export default {
  name: 'MenuItems',
  props: {
    menu: { type: Object, required: true },
    isRootMenu: { type: Boolean, default: false }
  },
  computed: {
    currentUser () {
      const value = this.$store.state.sysUserInfo
      if (typeof value !== 'string') return value || {}
      try {
        return JSON.parse(value) || {}
      } catch (error) {
        return {}
      }
    },
    hasChildren () {
      return Array.isArray(this.menu.children) && this.menu.children.length > 0
    },
    visible () {
      return this.canView(this.menu)
    }
  },
  methods: {
    canView (menu) {
      if (menu.hidden) return false
      const isAdmin = this.currentUser.remark === '0'
      if (menu.systemAdminOnly && !isAdmin) {
        if (!immediateRole(this.currentUser)) return false
        if (menu.index === 'immediateLoadingManager') return menu.children.some(child => this.canView(child))
        const module = immediateModules.find(item => item.index === menu.index)
        return Boolean(module && (this.currentUser.permissionCodes || []).includes(module.code))
      }
      if (Array.isArray(menu.children) && menu.children.length > 0) {
        return menu.children.some(child => this.canView(child))
      }
      const permissions = this.currentUser.permissionCodes || []
      return isAdmin || permissions.includes(menu.index)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/MenuItems.vue